import { GatewayService } from '../GatewayService';
import { PhicubeResponse } from '../interface/PhicubeResponse';

export class CadastroModel {
    name: String
    email: String
    cpf: String
    phone: String
    password: String
    passwordConfirm: String

    enviaCadastro(cadastroModel): Promise<PhicubeResponse> {
        return new GatewayService().requestPost('/api/user/register', cadastroModel, true)
    }
}